module.exports = __webpack_public_path__ + "img/herb-cilantro-350x184.257f306e.jpg";